import React from 'react';
import { Link, graphql } from 'gatsby';
import { motion } from 'framer-motion';
import styled from 'styled-components';

import { Grid } from '@material-ui/core';
import Main from '../components/Main';
import Chip from '../components/Chip';

const StyledH2 = styled(motion.h2)``;

const BlogPostTemplate = ({ data, pageContext }) => {
  const post = data.markdownRemark;
  const { previous, next } = pageContext;

  const toc = post.tableOfContents;

  return (
    <Main>
      <article>
        <header>
          <StyledH2
            style={{
              marginBottom: 0,
            }}
            // layoutId={`BlogTitle_${post.id}`}
            // transition={{ duration: 1 }}
          >
            {post.frontmatter.title}
          </StyledH2>
          <Grid container spacing={1}>
            {post.frontmatter.tags.map((elem) => (
              <Grid key={elem} item>
                <Chip link={elem} />
              </Grid>
            ))}
          </Grid>
          <p
            style={{
              display: `block`,
            }}
          >
            {post.frontmatter.date}
          </p>
        </header>
        <ul>{toc}</ul>
        <section dangerouslySetInnerHTML={{ __html: post.html }} />
        <hr style={{ backgroundColor: 'var(--color-text)' }} />
      </article>

      <nav>
        <ul
          style={{
            display: `flex`,
            flexWrap: `wrap`,
            justifyContent: `space-between`,
            listStyle: `none`,
            padding: 0,
          }}
        >
          <li>
            {next && (
              <Link to={next.fields.slug} rel="next">
                ← {next.frontmatter.title}
              </Link>
            )}
          </li>
          <li>
            {previous && (
              <Link to={previous.fields.slug} rel="prev">
                {previous.frontmatter.title} →
              </Link>
            )}
          </li>
        </ul>
      </nav>
    </Main>
  );
};

export default BlogPostTemplate;

export const pageQuery = graphql`
  query BlogPostBySlug($slug: String!) {
    site {
      siteMetadata {
        title
      }
    }
    markdownRemark(fields: { slug: { eq: $slug } }) {
      id
      excerpt(pruneLength: 160)
      html
      frontmatter {
        title
        date(formatString: "MMMM DD, YYYY")
        description
        tags
      }
      headings {
        depth
        id
        value
      }
    }
  }
`;
